import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import Bao from "./../../services/bao-service";
import * as $ from "jquery";
import * as ko from "knockout";
import GenericListSearchTab from "./../../factories/generic-list-search-tab";
class ConfigurationItemContractTab extends GenericListSearchTab {
    ConfigurationItem: any;
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.Parent = parent;
        this.ConfigurationItem = parent;
    }

    ControllerUrl = "ConfigurationItemContractTab";
    SearchType() {
        return "Contract";
    }
    CustomFilter(): Models.HashObject[] {
        return null;
    }

    ItemCompleteCheck(): JQueryPromise<boolean> {
        var def = $.Deferred<boolean>();
        def.resolve(true);
        return def.promise();
    }
}
export default ConfigurationItemContractTab;